// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"489":"b923f800","1275":"b923f800","1829":"b923f800","4866":"b923f800","5797":"b923f800","8541":"b923f800"}[chunkId] + ".chunk.css";
};